<template>
  <div class="apply-content-infos">
    <div class="step-con"  >
      <div v-for="item in list" :key="item.num" style="display: flex;">
      <div class="step-list" @mouseenter="active = item.num" >
        <div class="num">{{ item.num }}</div>
        <img
          :src="
            require(`../../../../assets/img/step${
              active === item.num ? '-active' : ''
            }2.png`)
          "
          alt
        />
        <div :class="{ title: true, 'blue-text-color': active === item.num }">
          {{$theme ? item.title : item.titleEng }}
        </div>
        <div
          v-if="$theme"
          :class="{ 'min-title': true, 'blue-text-color': active === item.num }"
        >
          {{ item.minTitle }}
        </div>
      </div>
      <div
        class="line-step"
        :key="'line' + item.num"
        v-if="item.num !== '05'"
      ></div>
    </div>
    </div>
    <div class="step-line"></div>
    <div class="join-us-btn" @click="job">{{$theme ? "立即加入！" : "JOIN NOW!"}}</div>
  </div>
</template>
<script>
export default {
  name: 'applyProcess',
  data() {
    return {
      list: [
        {
          num: '01',
          title: '简历投递',
          titleEng:'RESUME SUBMISSION',
          minTitle: '邮箱投递简历'
        },
        {
          num: '02',
          title: '简历筛选',
          titleEng:'RESUME SCREENING',
          minTitle: '投递简历筛选'
        },
        {
          num: '03',
          title: '面试',
          titleEng:'INTERVIEW',
          minTitle: '面试3-4轮'
        },
        {
          num: '04',
          title: 'OFFER',
          titleEng:'OFFER',
          minTitle: '意向书/OFFER'
        },
        {
          num: '05',
          title: '入职',
          titleEng:'ENTRY',
          minTitle: '员工入职'
        }
      ],
      active: '01',
    };
  },
  methods: {
    job() {
      const {
        href
      } = this.$router.resolve({
        path: `/job-list/0/0`
      });
      window.open(href, '_blank');
      // this.$router.push('/job-list/0/0');
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./index";
</style>